module.exports = __webpack_public_path__ + "static/media/logo-oracle-db-200.34609870.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/tech-stack/logo-oracle-db-200.png
// module id = 56
// module chunks = 0